import { css } from "@emotion/react";

export const content = css`
  padding-top: 1rem;

  & > * {
    padding: 0 0 0 0.5rem;
  }
`;

export const item = css`
  padding: 0 0 0 1rem;
`;

export const link = css`
  padding: 1rem 0 1rem 1.5rem;
  align-items: center;
  display: flex;
`;

export const borderLess = css`
  border: 0;
`;

export const trigger = css`
  padding: 1rem;
`;
